import { DataModel } from "../../../../lib/data/model/DataModel.js";

export class SettingModel extends DataModel {

    static _instance = null;

    static getInstance(authManager) {

        if (SettingModel._instance == null) SettingModel._instance = new SettingModel(authManager);
        return SettingModel._instance;

    }

    constructor (authManager) {

        super(authManager, 'core/settings');

        this.entityName = 'core.Setting';
        this.privileges = {
            create: [["#admin"]],
            read: [["#everyone"]],
            update: [["#admin"]],
            delete: [["#admin"]],
        };

        this.label = 'Setting';
        this.setLabel = 'Settings';

        this.browser = {
            name: 'default-core-setting-browser',
            moduleName: 'default-core-setting-browser',
            moduleTitle: 'Settings',
            moduleStateSlotName: 'default-core-setting-browser',
        };

        this.editor = {
            name: 'default-core-setting-editor',
            moduleName: 'default-core-setting-editor',
            moduleTitle: 'Setting',
            moduleStateSlotName: 'default-core-setting-editor',
        };

        this.fieldDefs = [
            {
                name: 'id',
                type: 'int',
                persistent: true,
                label: '#ID',
                primaryKey: true,
                required: true,
                readOnly: true,
            },
            {
                name: 'name',
                type: 'string',
                persistent: true,
                label: 'Name',
                required: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'type',
                type: 'string',
                persistent: true,
                label: 'Datový typ',
            },
            {
                name: 'value',
                type: 'string',
                persistent: true,
                label: 'Value',
            },
            {
                name: 'valueInt',
                type: 'int',
                persistent: true,
                label: 'Integer Value',
            },
            {
                name: 'valueFlt',
                type: 'float',
                persistent: true,
                label: 'Decimal Value',
            },
            {
                name: 'valueTxt',
                type: 'text',
                persistent: true,
                label: 'Text Hodnota',
            },
            {
                name: 'group',
                type: 'string',
                persistent: true,
                label: 'Skupina',
            },
            {
                name: 'label',
                type: 'string',
                persistent: true,
                label: 'Titulek',
            },
            {
                name: 'description',
                type: 'text',
                persistent: true,
                label: 'Popis',
            },
            {
                name: 'displayLabel',
                type: 'string',
                persistent: false,
                label: 'Display Label',
                readOnly: true,
            },
            {
                name: 'displayPosition',
                type: 'int',
                persistent: true,
                label: 'Display Position',
                inEditor: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'displayDisabled',
                type: 'bool',
                persistent: false,
                label: 'Display Disabled',
                readOnly: true,
            },
        ];

    }

}
